export default __webpack_public_path__ + "static/media/placeholder.c570ab88.jpg";